export default {"src":"/images/10.jpg","width":750,"height":1000,"aspectRatio":0.75};